<template>
  <div class="page full-page">
    <ActivityOrder :order="order" />
    <div class="submit-box">
      <van-button
        type="primary"
        v-show="cancelShow"
        :disabled="submiting"
        block
        @click="submitData"
        >取消报名</van-button
      >
    </div>
  </div>
</template>
<script>
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { checkResponse } from "@/assets/js/utils";
import debounce from "lodash.debounce";
import {
  activityOrderCancelAPI,
  ActivityOrderDetailAPI,
  activityDetailAPI,
} from "@/api/activity";
import ActivityOrder from "./components/ActivityOrder";
import dayjs from "dayjs";

export default {
  name: "ActivityOrderDetail",
  components: { ActivityOrder },
  data() {
    return {
      submiting: false,
      order: null,
      cancelShow: false,
    };
  },
  mounted() {
    BridgeNativeMethods.setTitle("报名详情");
    this.debouncedClick = debounce(this.submitData, 500);
    this.requestData();
  },
  unmounted() {
    // 移除组件时，取消定时器
    this.debouncedClick.cancel();
  },
  methods: {
    requestData() {
      BridgeNativeMethods.showLoading();
      ActivityOrderDetailAPI(this.$route.params.id).then(
        (response) => {
          this.order = response.data;
 BridgeNativeMethods.hideLoading();
          this.requestActivity();
        },
        (err) => {
          BridgeNativeMethods.hideLoading();
          console.log(err);
        }
      );
    },
    submitData() {
      this.submiting = true;
      activityOrderCancelAPI(this.order.signUpCode).then(
        (response) => {
          if (checkResponse(response)) {
            BridgeNativeMethods.showToast("取消报名成功");
            this.cancelShow = false;
            this.$router.replace({
              name: "ActivityOrderList",
            });
            this.submiting = false;
          } else {
            this.submiting = false;
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          this.submiting = false;
          BridgeNativeMethods.showToast("请求错误");
          console.log(err);
        }
      );
    },
    requestActivity() {
      activityDetailAPI(this.order.activity.Id).then(
        (response) => {
          console.log(response);
          if (checkResponse(response)) {
            let { signUpEndTime } = response.data;

            this.cancelShow = dayjs().isBefore(dayjs.unix(signUpEndTime));
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
.page {
  padding-top: 16px;
}
.submit-box {
  position: fixed;
  bottom: 0;
  left: 16px;
  right: 16px;
  bottom: 8px;
}
</style>